

// // import React, { useRef, useState } from "react";
// // import Layout from "../components/Layout";
// // import Drawer from "../components/Drawer";
// // import Footer from "../components/Footer";
// // import classes from "./ShortzPage.module.css";

// // import Feed from "../components/Feed";
// // import ScrollToTopButton from "../components/ScrollToTopButton";

// // const ShortzPage = () => {
// //   const containerRef = useRef(null);
// //   const [showScrollButton, setShowScrollButton] = useState(false);

// //   const handleScroll = () => {
// //     if (containerRef.current.scrollTop > 300) {
// //       setShowScrollButton(true);
// //     } else {
// //       setShowScrollButton(false);
// //     }
// //   };

// //   return (
// //     <Layout active={null}>
// //       <Drawer active={null} />
// //       <Feed
// //         containerRef={containerRef}
// //         onScroll={handleScroll}
// //         classes={classes}
// //       />
// //       <Footer />

// //       {/* ⬇️ Move ScrollToTopButton *after* footer so it floats freely */}
// //       <ScrollToTopButton
// //         containerRef={containerRef}
// //         isVisible={showScrollButton}
// //       />
// //     </Layout>
// //   );
// // };

// // export default ShortzPage;



// import React, { useRef, useState, useEffect } from "react";
// import Layout from "../components/Layout";
// import Drawer from "../components/Drawer";
// import Footer from "../components/Footer";
// import classes from "./ShortzPage.module.css";

// import Feed from "../components/Feed";
// import ScrollToTopButton from "../components/ScrollToTopButton";

// import { useSwipeable } from "react-swipeable";   // 👈 added for swipe support
// import { motion } from "framer-motion";          // 👈 added for animation

// const ShortzPage = () => {
//   const containerRef = useRef(null);
//   const [showScrollButton, setShowScrollButton] = useState(false);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const handleScroll = () => {
//     if (!containerRef.current) return;

//     const cards = containerRef.current.querySelectorAll(`.${classes.card}`);
//     let closestIndex = 0;
//     let closestOffset = Infinity;

//     cards.forEach((card, index) => {
//       const offset = Math.abs(card.offsetTop - containerRef.current.scrollTop);
//       if (offset < closestOffset) {
//         closestOffset = offset;
//         closestIndex = index;
//       }
//     });

//     setCurrentIndex(closestIndex);

//     if (containerRef.current.scrollTop > 300) {
//       setShowScrollButton(true);
//     } else {
//       setShowScrollButton(false);
//     }
//   };

//   // 👇 Swipe handlers (Inshorts-like)
//   const handlers = useSwipeable({
//     onSwipedUp: () => {
//       scrollToCard(currentIndex + 1);
//     },
//     onSwipedDown: () => {
//       scrollToCard(currentIndex - 1);
//     },
//     preventDefaultTouchmoveEvent: true,
//     trackMouse: true,
//   });

//   const scrollToCard = (index) => {
//     const cards = containerRef.current.querySelectorAll(`.${classes.card}`);
//     if (index >= 0 && index < cards.length) {
//       cards[index].scrollIntoView({ behavior: "smooth" });
//     }
//   };

//   useEffect(() => {
//     const ref = containerRef.current;
//     if (ref) ref.addEventListener("scroll", handleScroll);
//     return () => {
//       if (ref) ref.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

//   return (
//     <Layout active={null}>
//       <Drawer active={null} />

//       {/* Feed with swipe + animation */}
//       <div
//         {...handlers}
//         ref={containerRef}
//         className={classes.feedContainer}
//       >
//  <Feed
//   containerRef={containerRef}
//   onScroll={handleScroll}
//   classes={classes}
//   currentIndex={currentIndex}
//   MotionWrapper={motion.div}   // ✅ directly pass motion.div
// />

//       </div>

//       <Footer />

//       {/* Scroll-to-top floating button */}
//       <ScrollToTopButton
//         containerRef={containerRef}
//         isVisible={showScrollButton}
//       />

    
//     </Layout>
//   );
// };

// export default ShortzPage;



import React, { useRef, useState, useEffect } from "react";
import Layout from "../components/Layout";
import Drawer from "../components/Drawer";
import Footer from "../components/Footer";
import classes from "./ShortzPage.module.css";

import Feed from "../components/Feed";
import ScrollToTopButton from "../components/ScrollToTopButton";

import { useSwipeable } from "react-swipeable";
import { motion } from "framer-motion";

const ShortzPage = () => {
  const containerRef = useRef(null);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  // ✅ Smooth scroll to a card
  const scrollToCard = (index) => {
    const cards = containerRef.current.querySelectorAll(`.${classes.card}`);
    if (index >= 0 && index < cards.length) {
      cards[index].scrollIntoView({ behavior: "smooth", block: "start" });
      setCurrentIndex(index);
    }
  };

  // ✅ Swipe handlers
  const handlers = useSwipeable({
    onSwipedUp: () => scrollToCard(currentIndex + 1),
    onSwipedDown: () => scrollToCard(currentIndex - 1),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  // ✅ Track scroll position + closest card
  const handleScroll = () => {
    if (!containerRef.current) return;
    const cards = containerRef.current.querySelectorAll(`.${classes.card}`);
    let closestIndex = 0;
    let closestOffset = Infinity;

    cards.forEach((card, index) => {
      const offset = Math.abs(
        card.offsetTop - containerRef.current.scrollTop
      );
      if (offset < closestOffset) {
        closestOffset = offset;
        closestIndex = index;
      }
    });

    setCurrentIndex(closestIndex);
    setShowScrollButton(containerRef.current.scrollTop > 300);
  };

  useEffect(() => {
    const ref = containerRef.current;
    if (ref) ref.addEventListener("scroll", handleScroll);
    return () => {
      if (ref) ref.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Layout active={null}>
      <Drawer active={null} />

      {/* Feed with swipe + animation */}
      <div {...handlers} ref={containerRef} className={classes.feedContainer}>

        <Feed
          containerRef={containerRef}
          currentIndex={currentIndex}
          MotionWrapper={motion.div}
          classes={classes}
        />
      </div>

      <Footer />

      {/* Floating scroll-to-top button */}
      <ScrollToTopButton
        containerRef={containerRef}
        isVisible={showScrollButton}
      />
    </Layout>
  );
};

export default ShortzPage;

